import {
  connect,
  IAdFoxBannerProps as IAdFoxBannerComponentProps,
  IAdFoxBannerOnLoadData,
} from '@cian/adfox-component';
import { AdFoxTemplates } from '@cian/adfox-templates';
import * as React from 'react';

const AdFoxBannerComponent = connect(AdFoxTemplates);

interface IAdFoxBannerProps extends IAdFoxBannerComponentProps {
  disableYan?: boolean;
}

interface IAdFoxBannerState {
  isHidden: boolean;
}

export class AdFoxBanner extends React.Component<IAdFoxBannerProps, IAdFoxBannerState> {
  public state: IAdFoxBannerState = {
    isHidden: false,
  };

  public render() {
    const { disableYan, ...sharedProps } = this.props;
    const { isHidden } = this.state;

    if (disableYan && isHidden) {
      return null;
    }

    return <AdFoxBannerComponent {...sharedProps} onLoad={this.handleLoad} />;
  }

  private handleLoad = (data: IAdFoxBannerOnLoadData) => {
    const { bundleName } = data;
    const { disableYan } = this.props;

    if (disableYan && bundleName === 'banner.direct') {
      this.setState({
        isHidden: true,
      });
    }
  };
}
